import { JobSuggestion } from "@/modules/types/job/job";
import { useCallback, useState } from "react";
import debounce from "lodash/debounce";
import { jobService } from "@/modules/services/jobService";
import { AppError } from "@/lib/utils/errors";

export const useSearchJob = () => {
  const [loading, setLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [jobSuggestions, setJobSuggestions] = useState<JobSuggestion[]>([]);

  const handleSearch = (event: React.ChangeEvent<HTMLInputElement>) => {
    setLoading(true);
    setSearchTerm(event.target.value);
    fetchJobSuggestions(event.target.value);
  };

  const fetchJobSuggestions = useCallback(
    debounce(async (keyword: string) => {
      try {
        const resp = await jobService.searchSuggestion(keyword);
        if (resp && resp.jobSuggests) {
          setJobSuggestions(resp.jobSuggests);
        }
      } catch (err) {
        const appErr = new AppError(err);
        appErr.setAction("useSearchJob.fetchJobSuggestions");
        appErr.setApiAction("jobService.searchSuggestion");
        appErr.logError();
      } finally {
        setLoading(false);
      }
    }, 300),
    []
  );

  return {
    searchJobSuggestionsTerm: searchTerm,
    handleSearchJobSuggestions: handleSearch,
    jobSuggestions,
    loadingJobSuggestions: loading,
  };
};
